import { Box } from 'reflexbox';
import * as graphql from 'generated/graphql';

import useUserRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';
import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';

import Checkpoints from './Checkpoints';
import InboxPersonalInformation from './InboxPersonalInformation';

export default function InboxPersonalSidebar() {
	const roles = useUserRoles();
	const showCheckpoints = useFeature(graphql.FeatureName.Checkpoints);

	return (
		<>
			<Box mb={4}>
				<InboxPersonalInformation />
			</Box>

			{roles.isWorkspaceSuperuser && showCheckpoints && (
				<Checkpoints
					checkpoints={[
						{
							checkpoint: 'workspace.settings.theme',
							url: '/settings/theme',
						},
						{
							checkpoint: 'organization.goals',
							url: '/organization/goals',
						},
						{
							checkpoint: 'workspace.settings.jobTitles',
							url: '/settings/job-titles/create',
						},
						{
							checkpoint: 'workspace.departments.create',
							url: '/settings/departments',
						},
						{
							checkpoint: 'workspace.users.create',
							url: '/employees',
						},
						{
							checkpoint: 'workspace.learningEvents.create',
							url: '/learning/event/create',
						},
					]}
				/>
			)}
		</>
	);
}
